var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m454.85,130.42l0.27,-0.27l-98.86,-98.86l-28.17,28.17l56.07,56.07c-24.98,9.57 -42.79,33.49 -42.79,61.92c0,36.67 29.76,66.44 66.44,66.44c9.57,0 18.34,-2.13 26.58,-5.58l0,191.61c0,14.62 -11.96,26.58 -26.58,26.58s-26.58,-11.96 -26.58,-26.58l0,-119.59c0,-29.23 -23.92,-53.15 -53.15,-53.15l-26.58,0l0,-186.03c0,-29.23 -23.92,-53.15 -53.15,-53.15l-159.45,0c-29.23,0 -53.15,23.92 -53.15,53.15l0,425.21l265.76,0l0,-199.32l39.86,0l0,132.88c0,36.67 29.76,66.44 66.44,66.44s66.44,-29.76 66.44,-66.44l0,-252.47c0,-18.34 -7.44,-35.08 -19.4,-47.04zm-47.04,73.61c-14.62,0 -26.58,-11.96 -26.58,-26.58s11.96,-26.58 26.58,-26.58s26.58,11.96 26.58,26.58s-11.96,26.58 -26.58,26.58zm-265.76,212.61l0,-119.59l-53.15,0l106.3,-199.32l0,132.88l53.15,0l-106.3,186.03z",
    fill: "white",
    stroke: "grey"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricCharging);
export default __webpack_public_path__ + "static/media/electricCharging.b2f50ae6fcb23c47346c977bd2e9c251.svg";
export { ForwardRef as ReactComponent };